import { useState } from 'react';
import { CirclePlay, FileText } from 'lucide-react';
import { Button } from './ui/button';
import { VideoLightbox } from './VideoLightbox';
import { cn } from '@design-system';

interface ExplainSlideButtonProps {
  videoUrl: string;
  articleUrl?: string;
  className?: string;
}

export function ExplainSlideButton({ videoUrl, articleUrl, className }: ExplainSlideButtonProps) {
  const [showVideoModal, setShowVideoModal] = useState(false);

  function handleClick() {
    if (articleUrl) {
      window.open(articleUrl, '_blank', 'noopener,noreferrer');
    } else {
      setShowVideoModal(true);
    }
  }

  function getButtonContent() {
    if (articleUrl) {
      return (
        <>
          <FileText className="text-primary !h-5 !w-5" />
          <span className="hidden md:inline">Read Guide</span>
        </>
      );
    } else {
      return (
        <>
          <CirclePlay className="text-primary !h-5 !w-5" />
          <span className="hidden md:inline">Explain Slide</span>
        </>
      );
    }
  }

  return (
    <>
      <div className={cn('fixed bottom-8 left-8 right-auto top-auto z-50', className)}>
        <Button
          variant="outline"
          size="lg"
          onClick={handleClick}
          className="btn-purple-sheen animate-border-pulse border-primary-300 text-primary-dark hover:bg-primary-50 relative flex h-[34px] w-[34px] items-center justify-center overflow-hidden rounded-full border bg-white px-3 py-3 shadow-lg transition-shadow hover:animate-none hover:shadow-xl disabled:cursor-not-allowed disabled:opacity-60 disabled:hover:bg-white disabled:hover:shadow-lg md:h-auto md:w-auto md:px-4"
        >
          {getButtonContent()}
        </Button>
      </div>
      {!articleUrl && (
        <VideoLightbox
          videoUrl={videoUrl}
          isOpen={showVideoModal}
          onOpenChange={setShowVideoModal}
        />
      )}
    </>
  );
}
